import { connect } from 'react-redux';
import { getCookie } from 'cookies-next';
import { DEFAULT_THEME } from '@constants/constants';
import urlsService from '@/services/urls-service';
import { AppDispatch, AppRootState } from '@/configureStore';
import { getProducts } from '../stores/productSearchSlice';
import { selectProductSearchEntities, selectProductSearchLoading, selectSearchResultCount } from '../stores/selectors';
import { SearchBox } from '../Components/SearchBox';

const mapStateToProps = (state: AppRootState, ownProps?: any) => {
  const initialShouldDisplayResults = Object.keys(selectProductSearchEntities(state)).length > 0 ?? false;

  const loadingState = selectProductSearchLoading(state);
  const isSearchFullfilled = loadingState === 'fulfilled' ?? false;
  const isSearchPending = loadingState === 'pending' ?? false;
  const searchResultCount = selectSearchResultCount(state);

  const props = {
    ...ownProps,
    showAddToCartButton: ownProps?.showAddToCartButton ?? true,
    initialShouldDisplayResults,
    isSearchPending,
    isSearchFullfilled,
    searchResultCount
  };

  return {
    ...props,
    ...state
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onSearchQueryChange: (searchQuery: string, page?: number, take?: number) => {
      const webPrefix = `${document.location.pathname}${document.location.search}`;
      const sector = getCookie('cl_sector') ?? DEFAULT_THEME;

      const apiUrl = urlsService.getUrl('/products/search', {
        queryParams: {
          ct: 3,
          sector: sector,
          wp: webPrefix,
          ...(searchQuery && { s: searchQuery }),
          ...(page && { page: page }),
          ...(take && { take: take })
        }
      });

      getProducts(dispatch)({ apiUrl });
    }
  };
};

export const ConnectedSearchBox = connect(mapStateToProps, mapDispatchToProps)(SearchBox);
